import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContexte';

/**
 * Composant pour protéger les routes nécessitant une authentification
 * Si l'utilisateur n'est pas connecté, il est redirigé vers la page de connexion
 * avec un paramètre indiquant l'ID du serveur auquel il tentait d'accéder
 */
const ProtectedRoute = ({ children }) => {
  const { token, loading, setRedirectTarget } = useAuth();
  const { serverId } = useParams(); // Récupérer l'ID du serveur dans l'URL si présent
  
  useEffect(() => {
    // Si nous avons un serverId et que l'utilisateur n'est pas connecté,
    // stocker cet ID pour y rediriger après la connexion
    if (!token && !loading && serverId) {
      setRedirectTarget(serverId);
    }
  }, [token, loading, serverId, setRedirectTarget]);

  // Si l'authentification est en cours de chargement, afficher un indicateur
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Si l'utilisateur n'est pas connecté, rediriger vers la connexion
  // avec le paramètre de redirection si un serverId est présent
  if (!token) {
    const redirectUrl = serverId ? 
      `/?redirect=${serverId}` : 
      '/';
    
    return <Navigate to={redirectUrl} replace />;
  }
  
  // Si l'utilisateur est authentifié, montrer le contenu protégé
  return children;
};

export default ProtectedRoute;